// FETCH RELATIONS
export const FETCH_RELATIONS_REQUEST = 'FETCH_RELATIONS_REQUEST';
export const FETCH_RELATIONS_SUCCESS = 'FETCH_RELATIONS_SUCCESS';
export const FETCH_RELATIONS_FAIL = 'FETCH_RELATIONS_FAIL';
// FETCH QUESTIONNAIRES
export const FETCH_QUESTIONNAIRES_REQUEST = 'FETCH_QUESTIONNAIRES_REQUEST';
export const FETCH_QUESTIONNAIRES_SUCCESS = 'FETCH_QUESTIONNAIRES_SUCCESS';
export const FETCH_QUESTIONNAIRES_FAIL = 'FETCH_QUESTIONNAIRES_FAIL';
// EXTEND SALESROUTES
export const EXTEND_SALESROUTES_REQUEST = 'EXTEND_SALESROUTES_REQUEST';
export const EXTEND_SALESROUTES_SUCCESS = 'EXTEND_SALESROUTES_SUCCESS';
export const EXTEND_SALESROUTES_FAIL = 'EXTEND_SALESROUTES_FAIL';
// FETCH QUESTIONNAIRE
export const FETCH_QUESTIONNAIRE_REQUEST = 'FETCH_QUESTIONNAIRE_REQUEST';
export const FETCH_QUESTIONNAIRE_SUCCESS = 'FETCH_QUESTIONNAIRE_SUCCESS';
export const FETCH_QUESTIONNAIRE_FAIL = 'FETCH_QUESTIONNAIRE_FAIL';
// FETCH PRODUCT DESCRIPTIONS
export const FETCH_PRODUCT_DESCRIPTIONS_REQUEST = 'FETCH_PRODUCT_DESCRIPTIONS_REQUEST';
export const FETCH_PRODUCT_DESCRIPTIONS_SUCCESS = 'FETCH_PRODUCT_DESCRIPTIONS_SUCCESS';
export const FETCH_PRODUCT_DESCRIPTIONS_FAIL = 'FETCH_PRODUCT_DESCRIPTIONS_FAIL';
// FETCH PRODUCT DESCRIPTION
export const FETCH_PRODUCT_DESCRIPTION_REQUEST = 'FETCH_PRODUCT_DESCRIPTION_REQUEST';
export const FETCH_PRODUCT_DESCRIPTION_SUCCESS = 'FETCH_PRODUCT_DESCRIPTION_SUCCESS';
export const FETCH_PRODUCT_DESCRIPTION_FAIL = 'FETCH_PRODUCT_DESCRIPTION_FAIL';
// FETCH SALESROUTES
export const FETCH_SALESROUTES_REQUEST = 'FETCH_SALESROUTES_REQUEST';
export const FETCH_SALESROUTES_SUCCESS = 'FETCH_SALESROUTES_SUCCESS';
export const FETCH_SALESROUTES_FAIL = 'FETCH_SALESROUTES_FAIL';
// FETCH SALESROUTE
export const FETCH_SALESROUTE_REQUEST = 'FETCH_SALESROUTE_REQUEST';
export const FETCH_SALESROUTE_SUCCESS = 'FETCH_SALESROUTE_SUCCESS';
export const FETCH_SALESROUTE_FAIL = 'FETCH_SALESROUTE_FAIL';
// CREATE SALESROUTE
export const CREATE_SALESROUTE_REQUEST = 'CREATE_SALESROUTE_REQUEST';
export const CREATE_SALESROUTE_SUCCESS = 'CREATE_SALESROUTE_SUCCESS';
export const CREATE_SALESROUTE_FAIL = 'CREATE_SALESROUTE_FAIL';
// UPDATE SALESROUTE
export const UPDATE_SALESROUTE_REQUEST = 'UPDATE_SALESROUTE_REQUEST';
export const UPDATE_SALESROUTE_SUCCESS = 'UPDATE_SALESROUTE_SUCCESS';
export const UPDATE_SALESROUTE_FAIL = 'UPDATE_SALESROUTE_FAIL';
// PATCH SALESROUTE
export const PATCH_SALESROUTE_REQUEST = 'PATCH_SALESROUTE_REQUEST';
export const PATCH_SALESROUTE_SUCCESS = 'PATCH_SALESROUTE_SUCCESS';
export const PATCH_SALESROUTE_FAIL = 'PATCH_SALESROUTE_FAIL';
// RESET FORM SALESROUTE
export const RESET_FORM_SALESROUTE_REQUEST = 'RESET_FORM_SALESROUTE_REQUEST';
export const RESET_FORM_SALESROUTE_SUCCESS = 'RESET_FORM_SALESROUTE_SUCCESS';
// PARTIAL UPDATE SALESROUTE
export const PARTIAL_UPDATE_SALESROUTE_ANSWERS_REQUEST = 'PARTIAL_UPDATE_SALESROUTE_ANSWERS_REQUEST';
export const PARTIAL_UPDATE_SALESROUTE_ANSWERS_SUCCESS = 'PARTIAL_UPDATE_SALESROUTE_ANSWERS_SUCCESS';
export const PARTIAL_UPDATE_SALESROUTE_ANSWERS_FAIL = 'PARTIAL_UPDATE_SALESROUTE_ANSWERS_FAIL';
export const PARTIAL_UPDATE_SALESROUTE_LOANS_REQUEST = 'PARTIAL_UPDATE_SALESROUTE_LOANS_REQUEST';
export const PARTIAL_UPDATE_SALESROUTE_LOANS_SUCCESS = 'PARTIAL_UPDATE_SALESROUTE_LOANS_SUCCESS';
export const PARTIAL_UPDATE_SALESROUTE_LOANS_FAIL = 'PARTIAL_UPDATE_SALESROUTE_LOANS_FAIL';
export const PARTIAL_UPDATE_SALESROUTE_EXTRADATA_REQUEST = 'PARTIAL_UPDATE_SALESROUTE_EXTRADATA_REQUEST';
export const PARTIAL_UPDATE_SALESROUTE_EXTRADATA_SUCCESS = 'PARTIAL_UPDATE_SALESROUTE_EXTRADATA_SUCCESS';
export const PARTIAL_UPDATE_SALESROUTE_EXTRADATA_FAIL = 'PARTIAL_UPDATE_SALESROUTE_EXTRADATA_FAIL';
export const PARTIAL_UPDATE_SALESROUTE_GENERALDATA_REQUEST = 'PARTIAL_UPDATE_SALESROUTE_GENERALDATA_REQUEST';
export const PARTIAL_UPDATE_SALESROUTE_GENERALDATA_SUCCESS = 'PARTIAL_UPDATE_SALESROUTE_GENERALDATA_SUCCESS';
export const PARTIAL_UPDATE_SALESROUTE_GENERALDATA_FAIL = 'PARTIAL_UPDATE_SALESROUTE_GENERALDATA_FAIL';
export const PARTIAL_UPDATE_SALESROUTE_QUOTATIONS_REQUEST = 'PARTIAL_UPDATE_SALESROUTE_QUOTATIONS_REQUEST';
export const PARTIAL_UPDATE_SALESROUTE_QUOTATIONS_SUCCESS = 'PARTIAL_UPDATE_SALESROUTE_QUOTATIONS_SUCCESS';
export const PARTIAL_UPDATE_SALESROUTE_QUOTATIONS_FAIL = 'PARTIAL_UPDATE_SALESROUTE_QUOTATIONS_FAIL';
export const PARTIAL_UPDATE_SALESROUTE_CONTRACT_REQUEST = 'PARTIAL_UPDATE_SALESROUTE_CONTRACT_REQUEST';
export const PARTIAL_UPDATE_SALESROUTE_CONTRACT_SUCCESS = 'PARTIAL_UPDATE_SALESROUTE_CONTRACT_SUCCESS';
export const PARTIAL_UPDATE_SALESROUTE_CONTRACT_FAIL = 'PARTIAL_UPDATE_SALESROUTE_CONTRACT_FAIL';
export const PARTIAL_UPDATE_SALESROUTE_CONTRACT_PRINT_REQUEST = 'PARTIAL_UPDATE_SALESROUTE_CONTRACT_PRINT_REQUEST';
export const PARTIAL_UPDATE_SALESROUTE_CONTRACT_PRINT_SUCCESS = 'PARTIAL_UPDATE_SALESROUTE_CONTRACT_PRINT_SUCCESS';
export const PARTIAL_UPDATE_SALESROUTE_CONTRACT_PRINT_FAIL = 'PARTIAL_UPDATE_SALESROUTE_CONTRACT_PRINT_FAIL';
export const PARTIAL_UPDATE_SALESROUTE_SUBSCRIPTION_REQUEST = 'PARTIAL_UPDATE_SALESROUTE_SUBSCRIPTION_REQUEST';
export const PARTIAL_UPDATE_SALESROUTE_SUBSCRIPTION_SUCCESS = 'PARTIAL_UPDATE_SALESROUTE_SUBSCRIPTION_SUCCESS';
export const PARTIAL_UPDATE_SALESROUTE_SUBSCRIPTION_FAIL = 'PARTIAL_UPDATE_SALESROUTE_SUBSCRIPTION_FAIL';
// SIMULATE QUOTATIONS ACTION
export const SIMULATE_QUOTATIONS_REQUEST = 'SIMULATE_QUOTATIONS_REQUEST';
export const SIMULATE_QUOTATIONS_SUCCESS = 'SIMULATE_QUOTATIONS_SUCCESS';
export const SIMULATE_QUOTATIONS_FAIL = 'SIMULATE_QUOTATIONS_FAIL';
//  SUBSCRIBE CONTRACTS ACTION
export const SUBSCRIBE_CONTRACTS_REQUEST = 'SUBSCRIBE_CONTRACTS_REQUEST';
export const SUBSCRIBE_CONTRACTS_SUCCESS = 'SUBSCRIBE_CONTRACTS_SUCCESS';
export const SUBSCRIBE_CONTRACTS_FAIL = 'SUBSCRIBE_CONTRACTS_FAIL';
// COMPUTE QUESTIONNAIRES ACTION
export const COMPUTE_QUESTIONNAIRES_REQUEST = 'COMPUTE_QUESTIONNAIRES_REQUEST';
export const COMPUTE_QUESTIONNAIRES_SUCCESS = 'COMPUTE_QUESTIONNAIRES_SUCCESS';
export const COMPUTE_QUESTIONNAIRES_FAIL = 'COMPUTE_QUESTIONNAIRES_FAIL';
// FETCH QUOTATION DESCRIPTIONS
export const FETCH_QUOTATION_DESCRIPTIONS_REQUEST = 'FETCH_QUOTATION_DESCRIPTIONS_REQUEST';
export const FETCH_QUOTATION_DESCRIPTIONS_SUCCESS = 'FETCH_QUOTATION_DESCRIPTIONS_SUCCESS';
export const FETCH_QUOTATION_DESCRIPTIONS_FAIL = 'FETCH_QUOTATION_DESCRIPTIONS_FAIL';
// CALCULATE OFFERS ACTION
export const CALCULATE_OFFERS_REQUEST = 'CALCULATE_OFFERS_REQUEST';
export const CALCULATE_OFFERS_SUCCESS = 'CALCULATE_OFFERS_SUCCESS';
export const CALCULATE_OFFERS_FAIL = 'CALCULATE_OFFERS_FAIL';
// COMPUTE BILLING MODES ACTION
export const COMPUTE_BILLING_MODES_REQUEST = 'COMPUTE_BILLING_MODES_REQUEST';
export const COMPUTE_BILLING_MODES_SUCCESS = 'COMPUTE_BILLING_MODES_SUCCESS';
export const COMPUTE_BILLING_MODES_FAIL = 'COMPUTE_BILLING_MODES_FAIL';
// SUBMIT CONTRACT ACTION
export const SUBMIT_CONTRACT_REQUEST = 'SUBMIT_CONTRACT_REQUEST';
export const SUBMIT_CONTRACT_SUCCESS = 'SUBMIT_CONTRACT_SUCCESS';
export const SUBMIT_CONTRACT_FAIL = 'SUBMIT_CONTRACT_FAIL';
// PUTONHOLD SALESROUTE ACTION
export const PUTONHOLD_SALESROUTE_REQUEST = 'PUTONHOLD_SALESROUTE_REQUEST';
export const PUTONHOLD_SALESROUTE_SUCCESS = 'PUTONHOLD_SALESROUTE_SUCCESS';
export const PUTONHOLD_SALESROUTE_FAIL = 'PUTONHOLD_SALESROUTE_FAIL';
// CANCEL SALESROUTE ACTION
export const CANCEL_SALESROUTE_REQUEST = 'CANCEL_SALESROUTE_REQUEST';
export const CANCEL_SALESROUTE_SUCCESS = 'CANCEL_SALESROUTE_SUCCESS';
export const CANCEL_SALESROUTE_FAIL = 'CANCEL_SALESROUTE_FAIL';
// PRINT SALESROUTE
export const PRINT_SALESROUTE_REQUEST = 'PRINT_SALESROUTE_REQUEST';
export const PRINT_SALESROUTE_SUCCESS = 'PRINT_SALESROUTE_SUCCESS';
export const PRINT_SALESROUTE_FAIL = 'PRINT_SALESROUTE_FAIL';
// SYNCHRONIZE_SALESROUTE_REQUEST
export const SYNCHRONIZE_SALESROUTE_REQUEST = 'SYNCHRONIZE_SALESROUTE_REQUEST';
export const SYNCHRONIZE_SALESROUTE_SUCCESS = 'SYNCHRONIZE_SALESROUTE_SUCCESS';
export const SYNCHRONIZE_SALESROUTE_FAIL = 'SYNCHRONIZE_SALESROUTE_FAIL';
// REDIRECT TO EDIT SALESROUTE VIEW
export const REDIRECT_TO_EDIT_SALESROUTE = 'REDIRECT_TO_EDIT_SALESROUTE';
// NO UPDATE SALESROUTE
export const NO_UPDATE_SALESROUTE = 'NO_UPDATE_SALESROUTE';
// CHANGE PERSON TYPE
export const CHANGE_PERSON_TYPE = 'CHANGE_PERSON_TYPE';
// EVENT QUOTATIONBLOCK EDIT DATA
export const QUOTATIONBLOCK_CHANGE_FIELD_REQUEST = 'QUOTATIONBLOCK_CHANGE_FIELD_REQUEST';
export const QUOTATIONBLOCK_CHANGE_FIELD_SUCCESS = 'QUOTATIONBLOCK_CHANGE_FIELD_SUCCESS';
export const QUOTATIONBLOCK_CHANGE_FIELD_FAIL = 'QUOTATIONBLOCK_CHANGE_FIELD_FAIL';
